import React, { Suspense, lazy } from 'react';

import { Loader } from '@components/Loader';

interface Opts {
  fallback: React.ReactNode;
}
type Unpromisify<T> = T extends Promise<infer P> ? P : never;

export const lazyLoad = <
  /* eslint-disable @typescript-eslint/no-explicit-any */
  T extends Promise<any>,
  U extends React.ComponentType<any>,
  /* eslint-enable @typescript-eslint/no-explicit-any */
>(
  importFunc: () => T,
  selectorFunc?: (_s: Unpromisify<T>) => U,
  opts: Opts = { fallback: <Loader /> },
) => {
  let lazyFactory: () => Promise<{ default: U }> = importFunc;

  selectorFunc &&
    (lazyFactory = () =>
      importFunc().then(module => ({ default: selectorFunc(module) })));

  const LazyComponent = lazy(lazyFactory);

  return (props: React.ComponentProps<U>): JSX.Element => (
    <Suspense fallback={opts.fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
